import BaseService from "../base.service";

class IndividualObjectiveType extends BaseService {
  constructor() {
    super("individual-objective-type");
  }
}

export default new IndividualObjectiveType();
